import tw from 'twin.macro';
import { Button, FilterItemWrapper, InputSliderRange } from '.';
import { ButtonColor, ButtonSize } from '../enums';
import strings from '../language/Swedish';
import { FilterMinMaxItem } from '../types/dataTypes';
import styled from 'styled-components';
const CenteredButtonContainer = styled.div`
  ${tw`flex justify-center items-center w-full`}
`;

interface Props<TFilter> {
  filterData: TFilter;
  filterItem: FilterMinMaxItem;
  handleResetMinMax: (id: string, resetValue?: number) => void;
  handleMinMaxChange: (id: string, value: number) => void;
  isMobileLandscape?: boolean;
}

const MinMaxInputFilter = <TFilter, TFilterParams extends keyof TFilter>({
  filterData,
  filterItem: { minId, maxId, label, valueLabel, min, max, icon, type, tooltip },
  handleResetMinMax,
  handleMinMaxChange,
  isMobileLandscape,
}: Props<TFilter>) => {
  const sliderValueMin = filterData[minId as TFilterParams] as number | null;
  const sliderValueMax = filterData[maxId as TFilterParams] as number | null;

  const isActive = sliderValueMin !== null && sliderValueMax !== null;

  return (
    <FilterItemWrapper
      label={label}
      icon={icon}
      tooltip={tooltip}
      handleReset={() => {
        handleResetMinMax(minId);
        handleResetMinMax(maxId);
      }}
      isActive={isActive}
      isMobileLandscape={isMobileLandscape}>
      {isActive ? (
        <InputSliderRange
          minId={minId}
          maxId={maxId}
          label={valueLabel}
          value={[sliderValueMin, sliderValueMax]}
          min={min}
          max={max}
          type={type}
          handleValueChange={handleMinMaxChange}
        />
      ) : (
        <CenteredButtonContainer>
          <Button
            color={ButtonColor.primary}
            size={ButtonSize.large}
            onClick={() => {
              handleResetMinMax(minId, min);
              handleResetMinMax(maxId, max);
            }}>
            {strings.filter.activate}
          </Button>
        </CenteredButtonContainer>
      )}
    </FilterItemWrapper>
  );
};

export default MinMaxInputFilter;
